module.exports = __webpack_public_path__ + "static/media/nee.9c14ffbd.ogg";